<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-21 13:20:39
 * @LastEditTime : 2025-08-22 08:55:06
 * @LastEditors  : yangxr
 * @Description  : 电子围栏-车辆设置
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\schedul\components\carSet.vue
-->
<template>
  <div>
    <el-dialog :visible.sync="dialog" width="1000px" :close-on-click-modal="false" @open="initData" @close="reset">
      <span slot="title" class="dialog-title">车辆设置</span>
      <div class="search">
        <span style="display: inline-block; margin-bottom: 10px">
          <span style="margin-right: 12px">车牌号</span>
          <el-input v-model="tableParams.plateNumber" style="width:150px;" placeholder="请输入"></el-input>
        </span>
        <span style="margin-left: 24px">
          <span style="margin-right: 12px">站点</span>
          <el-input v-model="tableParams.stationName" style="width:150px;" placeholder="请输入"></el-input>
        </span>
        <el-button style="margin-left: 24px" icon="el-icon-search" size="medium" class="bottom_all"
          @click="queryCarPage()">查 询</el-button>
        <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
      </div>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" :data="carTableData"
          tooltip-effect="dark">
          <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
          <template v-for="(item, index) in carTable">
            <el-table-column v-if="item" :key="index" :prop="item.prop" :label="item.label" :width="item.width"
              align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="item.label == '操作'">
                  <el-link type="success" style="margin-left: 24px;" :underline="false"
                    @click="addEngineeringCar(scope.row)">绑定</el-link>
                </span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ total }}条</div>
            <el-pagination :current-page.sync="tableParams.page" :page-size="tableParams.pageSize"
              :page-sizes="[5, 10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
              :total="total" @size-change="sizeChange" @current-change="queryCarPage()"></el-pagination>
          </div>
          <div>
            <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
              @click="getOrganization_HX">刷新</el-button>
          </div>
        </div>
        <div>已绑定车辆</div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" :data="carTableData2" height="240"
          tooltip-effect="dark">
          <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
          <template v-for="(item, index) in carTable2">
            <el-table-column v-if="item" :key="index" :prop="item.prop" :label="item.label" :width="item.width"
              align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="item.label == '操作'">
                  <el-link type="danger" style="margin-left: 24px;" :underline="false"
                    @click="cancelEngineeringCar(scope.row)">删除</el-link>
                </span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="reset">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { queryCarPage, queryEngineeringCarPage, addEngineeringCar, cancelEngineeringCar } from "@/api/smart/schedul/a.js";
export default {
  components: {
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    centerRow: {}
  },
  data() {
    return {
      tableParams: {
        page: 1,
        pageSize: 5,
        plateNumber: "",
        stationName: "",
      },
      tableParams2: {
        page: 1,
        pageSize: 99999,
        engineeringId: "",
      },
      total: 0,
      carTableData: [],
      carTableData2: [],//已绑定车辆数据
      carTable: [
        { label: "车辆自编码", width: "auto", prop: "code", status: true },
        { label: "车牌号", width: "auto", prop: "plateNumber", status: true },
        { label: "车辆类型", width: "auto", prop: "carTypeName", status: true },
        { label: "站点", width: "auto", prop: "stationName", status: true },
        { label: "操作", width: "auto", prop: "belongComName", status: true },
      ],
      carTable2: [
        { label: "车辆自编码", width: "auto", prop: "code", status: true },
        { label: "车牌号", width: "auto", prop: "carNo", status: true },
        { label: "车辆类型", width: "auto", prop: "carTypeName", status: true },
        { label: "站点", width: "auto", prop: "stationName", status: true },
        { label: "操作", width: "auto", prop: "belongComName", status: true },
      ],
      currentRow: {},
      form: {},
      ncNo: "",
      userName: "",
    }
  },
  watch: {

  },
  methods: {
    cancelEngineeringCar(row) {
      this.$confirm("是否取消绑定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          cancelEngineeringCar({ carNo: row.carNo }).then(res => {
            if (res.code == 1001) {
              this.$message.success("取消成功!");
              this.tableParams.page = 1
              this.queryCarPage()
              this.queryEngineeringCarPage()
            }
          });
        })
        .catch(() => { });
    },

    addEngineeringCar(row) {
      let carSame = this.carTableData2.some(item => item.code == row.code && item.carNo == row.plateNumber)
      if(carSame) {
        this.$message.warning('该车辆已绑定!')
        return
      }
      addEngineeringCar({ carNo: row.plateNumber, engineeringId: this.centerRow.id, engineeringName: this.centerRow.name }).then(res => {
        if (res.code == 1001) {
          this.$message.success('绑定成功!')
          this.queryCarPage()
          this.queryEngineeringCarPage()
        }
      })
    },
    init() {
      this.tableParams = this.$options.data().tableParams
    },
    async initData() {
      this.tableParams2.engineeringId = this.centerRow.id
      this.init()
      this.queryCarPage()
      this.queryEngineeringCarPage()
    },
    queryCarPage() {
      queryCarPage(this.tableParams).then(res => {
        if (res.code == 1001) {
          this.carTableData = res.data.data
          this.total = res.data.totalRows
        }
      })
    },
    queryEngineeringCarPage() {
      queryEngineeringCarPage(this.tableParams2).then(res => {
        if (res.code == 1001) {
          this.carTableData2 = res.data.data
        }
      })
    },
    setNcNo(data) {
      this.ncNo = data.code
      this.userName = data.name
    },
    reset() {
      this.$emit("resetCar");
    },
    sizeChange(value) {
      this.tableParams.pageSize = value;
      this.queryCarPage();
    },
  }
}
</script>
<style lang="scss" scoped>
.addClass {
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

::v-deep .el-table__body tr.current-row>td {
  color: #fff;
  background: #00b85c !important;
}
</style>